(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/barcode/index.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/barcode/index.js');
"use strict";

const payFooterTexts = {
  PRINT: 'Skriv ut',
  REDEEM_ONLINE: 'Skrapa online',
  SCRATCH_NEXT_VOUCHER: 'Skrapa nästa lott'
};
const Barcode = _ref => {
  let giftCode = _ref.giftCode,
    extraGiftCodes = _ref.extraGiftCodes,
    manual = _ref.manual,
    history = _ref.history,
    numberOfTickets = _ref.numberOfTickets,
    totalPrice = _ref.totalPrice,
    availableOnline = _ref.availableOnline,
    nextVoucher = _ref.nextVoucher;
  const PRINT = payFooterTexts.PRINT,
    REDEEM_ONLINE = payFooterTexts.REDEEM_ONLINE,
    SCRATCH_NEXT_VOUCHER = payFooterTexts.SCRATCH_NEXT_VOUCHER;
  const BarcodePrint = svs.ticket_gifts.barcode.components.BarcodePrint;
  const ManualInfo = svs.ticket_gifts.barcode.components.ManualInfo;
  const Payfooter = svs.tur.ReactPayfooter.Payfooter;
  const expirationDate = new URLSearchParams(location.search).get('expirationDate');
  const reactPayfooterCustomerServiceTexts = svs.ticket_gifts.constants.reactPayfooterCustomerServiceTexts;
  window.scroll(0, 0);
  const handleRedeemOnlineClick = e => {
    e && e.preventDefault();
    history && history.push("/".concat(giftCode).concat(history.location.search));
  };
  const handleRedeemOnlineClickNotLoggedIn = e => {
    e && e.preventDefault();
    svs.components.customer_login.login({
      returnNewCustomer: true,
      returnUrl: window.location.href.replace('/streckkod', ''),
      extraParams: {
        gift: true
      }
    });
  };
  const handlePrintClick = e => {
    e && e.preventDefault();
    window.print();
  };
  const handleGoToNext = e => {
    e === null || e === void 0 || e.preventDefault();
    history.push("../../".concat(giftCode));
    history.push("".concat(giftCode, "/spela/").concat(nextVoucher.voucherId));
  };
  const getPayFooterButtons = (nextVoucher, availableOnline) => {
    const payfooterButtons = [];
    payfooterButtons.push({
      secondary: true,
      text: PRINT,
      onClick: handlePrintClick
    });
    if (availableOnline) {
      payfooterButtons.push({
        secondary: true,
        text: REDEEM_ONLINE,
        onClick: handleRedeemOnlineClick
      });
    } else if (nextVoucher) {
      payfooterButtons.push({
        secondary: true,
        text: SCRATCH_NEXT_VOUCHER,
        onClick: handleGoToNext
      });
    } else if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      payfooterButtons.push({
        secondary: true,
        text: REDEEM_ONLINE,
        onClick: handleRedeemOnlineClickNotLoggedIn
      });
    }
    return payfooterButtons;
  };
  React.useEffect(() => {
    JsBarcode('#js-voucher-barcode', "VV".concat(giftCode), {
      format: 'code128',
      width: 2,
      displayValue: false
    });
  }, [giftCode]);
  React.useEffect(() => {
    extraGiftCodes === null || extraGiftCodes === void 0 || extraGiftCodes.forEach((code, index) => {
      JsBarcode("#js-voucher-barcode-".concat(index), "VV".concat(code), {
        format: 'code128',
        width: 2,
        displayValue: false
      });
    });
  }, [extraGiftCodes]);
  let header = '';
  let infoTop = 'Scanna streckkoden under kundskärmen med mobilen hos valfritt ombud för Svenska Spel.';
  let infoMid = 'Du kan även uppge koden för kassapersonalen.';
  let infoBot = 'Koden är en värdehandling tills dina lotter är uthämtade.';
  switch (true) {
    case extraGiftCodes && numberOfTickets > 1:
      header = 'Koder för fysiska lotter';
      break;
    case numberOfTickets > 1:
      header = "".concat(numberOfTickets, " lotter ").concat(totalPrice ? "till ett v\xE4rde av ".concat(totalPrice, "\xA0kr") : '');
      break;
    case !numberOfTickets:
      header = 'Kod för fysisk lott';
      break;
    case Number(numberOfTickets) === 1:
      header = "1 lott ".concat(totalPrice ? "till ett v\xE4rde av ".concat(totalPrice, "\xA0kr") : '');
      break;
    default:
  }
  if (extraGiftCodes && numberOfTickets > 1) {
    infoTop = 'Scanna streckkoderna under kundskärmen med mobilen hos valfritt ombud för Svenska Spel.';
    infoMid = 'Du kan även uppge koderna för kassapersonalen.';
    infoBot = 'Koderna är värdehandlingar tills dina lotter är uthämtade.';
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "barcode-print-wrapper"
  }, React.createElement(BarcodePrint, {
    expirationDate: expirationDate,
    extraGiftCodes: extraGiftCodes,
    giftCode: giftCode,
    manual: manual,
    numberOfTickets: numberOfTickets,
    totalPrice: totalPrice
  })), React.createElement("div", {
    className: "f-body f-center padding-bottom-2"
  }, React.createElement("div", {
    className: "margin-h-2"
  }, React.createElement("h1", {
    className: "h1 padding-top-2 padding-h-1 margin-1",
    role: "heading"
  }, header), React.createElement("p", {
    className: "p"
  }, infoTop), React.createElement("p", {
    className: "p"
  }, infoMid), React.createElement("p", {
    className: "p f-bold margin-bottom-2"
  }, infoBot), expirationDate && React.createElement("p", {
    className: "p f-bold"
  }, "Giltig till: ".concat(expirationDate)), React.createElement("h2", {
    className: manual ? 'h2 f-800 padding-top-2' : 'h2 margin-top-3 margin-bottom-1'
  }, giftCode && giftCode.replace(/ /g, '').replace(/(.{3})/g, '$1 ').trim()), manual && React.createElement(ManualInfo, null), React.createElement("div", null, React.createElement("img", {
    id: "js-voucher-barcode"
  })), extraGiftCodes === null || extraGiftCodes === void 0 ? void 0 : extraGiftCodes.map((code, index) => React.createElement("div", {
    className: "margin-top-2",
    key: code
  }, React.createElement("h2", {
    className: "h2 margin-top-0 margin-bottom-1"
  }, code && code.replace(/ /g, '').replace(/(.{3})/g, '$1 ').trim()), React.createElement("img", {
    id: "js-voucher-barcode-".concat(index)
  }))))), React.createElement(Payfooter, {
    buttons: getPayFooterButtons(nextVoucher, availableOnline),
    isBottom: true,
    texts: reactPayfooterCustomerServiceTexts
  }));
};
setGlobal('svs.ticket_gifts.barcode.components.payFooterTexts', payFooterTexts);
setGlobal('svs.ticket_gifts.barcode.components.Barcode', Barcode);

 })(window);